import {createContext} from 'react';

const cobrosContext = createContext();

export default cobrosContext;